var _path, _rect, _rect2, _path2, _path3, _path4, _g, _rect3, _ellipse, _ellipse2, _rect4, _path5, _g2, _path6, _path7, _path8, _ellipse3, _path9, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleWithShellLessEggInBeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 192,
    viewBox: "0 0 170 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2968 100.02C12.4876 98.1619 14.8232 97 17.3671 97H152.633C155.177 97 157.512 98.1619 158.703 100.02L167.529 113.791C169.044 116.154 166.971 119 163.735 119H6.26463C3.02878 119 0.955955 116.154 2.47064 113.791L11.2968 100.02Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 187.114,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.96533,
    y: 186.47,
    width: 17.5879,
    height: 4.20218,
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96533 145.944C1.96533 129.958 14.9238 117 30.9089 117H140.074C156.059 117 169.017 129.958 169.017 145.944V188H1.96533V145.944Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 120.648C0 115.32 4.3195 111 9.64787 111H160.352C165.68 111 170 115.319 170 120.648V186H0V120.648Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.364 169.104C149.364 174.432 145.045 178.752 139.716 178.752L29.3011 178.752C23.9727 178.752 19.6532 174.432 19.6532 169.104L19.6532 118.935L149.364 118.935L149.364 169.104Z",
    fill: "#CCD8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10223_46958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.416 122H22.6011V154.16H146.416V122Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.7557 122L34.1786 154.16H72.6149L132.587 122H93.7557Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M135.079 122L75.986 154.16H80.1776L139.662 122H135.079Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.783 122H23.8875C23.1771 122 22.6011 122.576 22.6011 123.286V154.544C22.6011 155.254 23.1771 155.83 23.8875 155.83H147.783C148.493 155.83 149.069 155.254 149.069 154.544V123.286C149.069 122.576 148.493 122 147.783 122Z",
    stroke: "#031D29",
    strokeWidth: 2.57277,
    strokeMiterlimit: 10
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1409,
    y: 101.569,
    width: 34.8025,
    height: 6.43191,
    fill: "#333333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2258,
    cy: 95.137,
    rx: 62.6445,
    ry: 11.5774,
    fill: "#838383"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5422,
    cy: 93.2075,
    rx: 63.5937,
    ry: 12.2206,
    fill: "#5C5C5C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    fill: "#A41034",
    stroke: "#C87085",
    strokeWidth: 1.28638
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10223_46958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 156,
    width: 43,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.02 156.884V161.386V183.898H69.3579V176.18H64.8555L69.3579 171.677V161.386H101.517L106.02 156.884Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10223_46958)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4987,
    y: 157.527,
    width: 39.8439,
    height: 18.0094,
    rx: 2.25117,
    stroke: "#830D2A",
    strokeWidth: 1.28638
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3953 169.976V168.922L79.1958 165.014H76.5574V163.852H80.8706V164.897L78.0702 168.814H80.9427V169.976H76.3953ZM83.7832 170.084C82.3605 170.084 81.6401 169.408 81.6401 168.085V167.166C81.6401 165.86 82.3605 165.167 83.7292 165.167C85.1069 165.167 85.8273 165.878 85.8273 167.184V168.04H82.9728V168.13C82.9728 168.742 83.2159 169.039 83.7922 169.039C84.2425 169.039 84.5036 168.859 84.5306 168.535H85.8003C85.7463 169.552 85.0529 170.084 83.7832 170.084ZM82.9728 167.103H84.5666C84.5666 166.473 84.3325 166.212 83.7742 166.212C83.2069 166.212 82.9728 166.473 82.9728 167.103ZM86.7884 169.976V165.275H87.923L87.977 166.149C88.1571 165.482 88.5263 165.185 89.1746 165.185H89.5258V166.428H89.2737C88.5803 166.428 88.2472 166.689 88.1211 167.346V169.976H86.7884ZM92.1458 170.084C90.723 170.084 90.0117 169.408 90.0117 168.058V167.193C90.0117 165.842 90.723 165.167 92.1458 165.167C93.5685 165.167 94.2799 165.842 94.2799 167.193V168.058C94.2799 169.408 93.5685 170.084 92.1458 170.084ZM92.1458 169.003C92.7131 169.003 92.9472 168.715 92.9472 168.031V167.22C92.9472 166.536 92.7131 166.248 92.1458 166.248C91.5785 166.248 91.3443 166.536 91.3443 167.22V168.031C91.3443 168.715 91.5785 169.003 92.1458 169.003Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.579 18.6781C121.125 19.5061 120.054 19.9312 119.046 19.6851L117.71 19.3494C113.974 20.8004 113.113 22.1525 113 26.5V87.3538C113 89.4461 111.417 91 109.06 91H61.5059C59.1363 91 57 89.4461 57 87.3538L56.6415 15.2107C56.6415 13.6891 56.1121 12.3342 55.1542 11.0587C54.65 10.0965 55.4441 9 56.6415 9H106.429C111.811 9 116.953 10.958 120.659 14.4041C122.008 15.4894 122.386 17.2348 121.579 18.6781Z",
    fill: "#D9ECF6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.712 64.5333C98.0092 52.5333 90.2446 46 85 46C79.7554 46 71.9908 52.5333 70.288 64.5333C68.6533 76.5333 74.0341 86 85 86C95.9659 86 101.347 76.5333 99.712 64.5333Z",
    fill: "url(#paint0_radial_10223_46958)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.0873,
    cy: 76.1712,
    rx: 7.58721,
    ry: 7.4359,
    fill: "url(#paint1_radial_10223_46958)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 16C61 15.4477 61.4477 15 62 15H71C71.5523 15 72 15.4477 72 16C72 16.5523 71.5523 17 71 17H63V29H71C71.5523 29 72 29.4477 72 30C72 30.5523 71.5523 31 71 31H63V43H71C71.5523 43 72 43.4477 72 44C72 44.5523 71.5523 45 71 45H63V57H71C71.5523 57 72 57.4477 72 58C72 58.5523 71.5523 59 71 59H63V71H71C71.5523 71 72 71.4477 72 72C72 72.5523 71.5523 73 71 73H63V85H71C71.5523 85 72 85.4477 72 86C72 86.5523 71.5523 87 71 87H62C61.4477 87 61 86.5523 61 86V72V58V44V30V16Z",
    fill: "#668BA6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 14,
    width: 13,
    height: 73,
    rx: 3,
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10223_46958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85 66) rotate(90) scale(20 15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DD98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10223_46958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.0873 76.1712) rotate(90) scale(7.4359 7.58721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10223_46958"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.6011,
    y: 122,
    width: 123.815,
    height: 32.1596,
    rx: 1.28638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleWithShellLessEggInBeaker);
export default __webpack_public_path__ + "static/media/scale_with_shell_less_egg_in_beaker.59761fc3cee336fc376eb84e5a569d96.svg";
export { ForwardRef as ReactComponent };